import z from 'zod';

export const AppointmentTags = {
  SystemMetadata: {
    API_SYNC: 'Synced to EHR via API-based approach.',
    DOM_SYNC:
      'Synced to EHR via DOM-based approach (marked as synced in extension).',
    FILE_UPLOAD_ATTEMPTED: 'An attempt was made to upload a file.',
  },
  SystemSelfResolvable: {
    TRANSCRIPT_FAILURE: 'The transcription of an audio file has failed.',
    TRANSCRIPT_REPEAT: 'Repeated text inside of a transcript.',
    TRANSCRIPT_OR_AUDIO_TIMEOUT:
      'Indicates that the appointment has exceeded the time limit while waiting for audio or transcription.',
    ZERO_BYTE_AUDIO_FILE:
      'Audio file was uploaded with 0 bytes, transcription was cancelled.',
    UPLOAD_FILE_NETWORK_FAILURE:
      'Indicates that a file upload failed after all retry attempts due to network issues.',
    ATTEMPTED_SUMMARY_WITH_SHORT_TRANSCRIPT:
      'Indicates that the appointment attempted to summarize a transcript that was too short.',
    ATTEMPTED_SUMMARY_WITH_DEGRADED_TRANSCRIPT:
      'Indicates that the appointment attempted to summarize a transcript that was degraded.',
    INCLUDES_SILENT_TRANSCRIPT:
      'Audio file was detected as silent, transcription returned empty result.',
  },
  SystemAppliedForHumanAction: {
    OVERRIDE_AUDIO_FILE_AND_TRANSCRIPT_AS_CANCELED:
      'Indicates that a human has overridden the audio file and transcript as canceled.',
  },
  HumanApplied: {
    ON_CALL_INTERVENTION:
      'Indicates that a human intervened during the appointment.',
    RECORDED_AGAINST_WRONG_PATIENT:
      'Indicates that the appointment was recorded against the wrong patient and needs to be reassigned.',
    CUSTOMER_REPORTED_HALLUCINATION:
      'Indicates that a customer reported a hallucination in the appointment summary or transcript.',
  },
} as const satisfies Record<string, Record<string, string>>;

export type AppointmentTagOption<
  TType extends keyof typeof AppointmentTags,
  TKey extends keyof (typeof AppointmentTags)[TType],
> = {
  type: TType;
  key: TKey;
};

type AppointmentTagType = keyof typeof AppointmentTags;

type AppointmentTagKey = {
  [K in keyof typeof AppointmentTags]: keyof (typeof AppointmentTags)[K];
}[keyof typeof AppointmentTags];

const allTagKeys = Object.values(AppointmentTags).flatMap((tagGroup) =>
  Object.keys(tagGroup),
) as AppointmentTagKey[];

export const appointmentTagTypeSchema = z.enum(
  Object.keys(AppointmentTags) as [AppointmentTagType, ...AppointmentTagType[]],
);

export const appointmentTagKeySchema = z.enum(
  allTagKeys as [AppointmentTagKey, ...AppointmentTagKey[]],
);
